import { render, staticRenderFns } from "./ListDeletedTradeIn.vue?vue&type=template&id=2176ceb8&scoped=true"
import script from "./ListDeletedTradeIn.vue?vue&type=script&lang=js"
export * from "./ListDeletedTradeIn.vue?vue&type=script&lang=js"
import style0 from "./ListDeletedTradeIn.vue?vue&type=style&index=0&id=2176ceb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2176ceb8",
  null
  
)

export default component.exports